import React, { useEffect } from 'react';
import styled from 'styled-components';

// Components
import { ButtonHighlight } from '../../button';
import LinkinIcon from '../../../images/linked-in.png';

const ContactWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: auto;
`;

const DetailWrapper = styled.div`
  padding: 142px 114px;
  padding-bottom: 124px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 1112px) {
    padding: 62px 56px;
    display: block;
  }

  @media (max-width: 768px) {
    padding: 62px 24px;
    padding-bottom: 53px;
  }
`;

const AddressWrapper = styled.div``;

const TextWrapper = styled.div`
  @media (min-width: 1024.1px) and (max-width: 1112px) {
    width: 35%;
  }
  @media (max-width: 1024px) {
    margin-left: 45px;
  }
  @media (max-width: 767.9px) {
    margin-left: 0;
  }
`;

const TextWrapperSubHeader = styled.div`
  ${({ theme }) => theme.typography.footerSubHeadline()};
  max-width: 900px;
  width: 100%;

  @media (max-width: 1024px) {
    max-width: 100%;
  }
`;

const CaptionWrapper = styled.div`
  color: ${({ theme }) => theme.color.textWhite};
  line-height: 60px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    text-align: center;
    margin: 0 0 30px 0;
  }
`;

const TextTitle = styled.div`
  ${({ theme }) => theme.typography.footageDetail()};
  color: ${({ theme }) => theme.color.titleLightBlue};
  margin-bottom: 11px;
  width: auto;
`;

const TextAddress = styled.div`
  ${({ theme }) => theme.typography.footerTextContent()};
  color: ${({ theme }) => theme.color.textWhite};
  line-height: 24px;
  margin-bottom: 24px;

  @media (min-width: ${({ theme }) => theme.device.mobileL}) {
    white-space: inherit;
    padding-right: 0;
  }
`;

const TextEmail = styled.div`
  line-height: 24px;
  margin-bottom: 22px;

  ${({ theme }) => theme.typography.footerTextContent()};
  color: ${({ theme }) => theme.color.textWhite};
  background-color: none;
  transition: color 0.1s;

  &:hover {
    color: ${({ theme }) => theme.color.textLinkHover};
  }
`;

const MailTextStyle = styled.a`
  line-height: 24px;
  margin-bottom: 24px;

  ${({ theme }) => theme.typography.footerTextContent()};
  color: ${({ theme }) => theme.color.textWhite};
  background-color: none;
  transition: color 0.1s;
`;
const SocialLink = styled.a``;

const ContentStyle = styled.div`
  width: 617px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    text-align: left;
    font-size: 36px;
    line-height: 46px;
  }

  @media (max-width: 767.9px) {
    width: 290px;
  }

  @media (min-width: 500px) and (max-width: 700px) and (orientation: landscape) {
    width: 100%;
  }
`;

const IconStyle = styled.img`
  width: 46px;
`;
const IconLabel = styled.div`
  display: flex;
`;
const ContactOnline = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;

  @media (max-width: 1112px) {
    margin-top: 20px;
    justify-content: space-between;
    padding-right: 85px;
  }

  @media (max-width: 767.9px) {
    display: block;
  }
`;
const AddressStyle = styled.div``;

const Contact = () => {
  useEffect(() => {
    const root = document.getElementById('isFooter');

    root.addEventListener('mousemove', (evt) => {
      let x = evt.offsetX / window.innerWidth;
      let y = evt.offsetY / window.innerHeight;
      root.style.setProperty('--mouse-x', x);
      root.style.setProperty('--mouse-y', y);
    });

    root.addEventListener('mouseout', () => {
      root.style.setProperty('--mouse-x', -50);
      root.style.setProperty('--mouse-y', -50);
    });
  }, []);

  return (
    <ContactWrapper>
      <DetailWrapper>
        <TextWrapperSubHeader>
          <CaptionWrapper>
            <ContentStyle>Projekte, Ideen oder Feedback - kontaktiert uns gerne!</ContentStyle>
            <ButtonHighlight
              href="mailto:mail@20scoops.com"
              id="isFooter"
              target="_blank"
              rel="noopener noreferrer"
              className="footerBar"
            >
              Termin vereinbaren
            </ButtonHighlight>
          </CaptionWrapper>
        </TextWrapperSubHeader>
        <ContactOnline>
          <AddressWrapper>
            <TextTitle>Kontakt</TextTitle>
            <TextAddress>
              <AddressStyle>20IT Innovation Technology GmbH & Co. KG</AddressStyle>
              <AddressStyle>Rathausstraße 7</AddressStyle>
              <AddressStyle>20095 Hamburg</AddressStyle>
              <AddressStyle>Amtsgericht Hamburg HRA 120351</AddressStyle>
            </TextAddress>
          </AddressWrapper>
          <TextWrapper>
            <TextTitle>E-Mail an</TextTitle>
            <TextEmail>
              <MailTextStyle href="mailto:mail@20it.de">mail@20it.de</MailTextStyle>
            </TextEmail>
            <IconLabel>
              <SocialLink
                href="https://www.linkedin.com/company/42405257"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconStyle src={LinkinIcon} alt="Linkedin Icon" />
              </SocialLink>
            </IconLabel>
          </TextWrapper>
        </ContactOnline>
      </DetailWrapper>
    </ContactWrapper>
  );
};

export default Contact;
